import { createQueryKeys } from '@lukemorales/query-key-factory';

import { getMindCoins } from '@/services/mindCoins';
import {
  getAvailablePricingForType,
  getCustomerPortal,
  getPackages,
  getProducts,
  getTrialStatusData,
  getUserCurrentSubscriptionData,
  getValidateAccessCode,
  type PageType,
} from '@/services/payments';

export const payments = createQueryKeys('payments', {
  products: {
    queryKey: null,
    queryFn: getProducts,
  },
  customerPortal: (callbackUrl?: string) => ({
    queryKey: [callbackUrl],
    queryFn: () => getCustomerPortal(callbackUrl),
  }),
  packages: {
    queryKey: null,
    queryFn: getPackages,
  },
  getUserCurrentSubscriptionData: {
    queryKey: null,
    queryFn: getUserCurrentSubscriptionData,
  },
  getAvailablePricingForType: (type: PageType) => ({
    queryKey: [type],
    queryFn: () => getAvailablePricingForType(type),
  }),
  hasUserUsedTrial: {
    queryKey: null,
    queryFn: getTrialStatusData,
  },
  validateAccessCode: (code: string) => ({
    queryKey: [code],
    queryFn: () => getValidateAccessCode(code),
  }),
  mindCoins: {
    queryKey: null,
    queryFn: getMindCoins,
  },
});
